import englishGB from './en-Gb'

const locales = {
  [englishGB.locale]: englishGB,
}

export default locales
